class AccountSettings.AttributesValidationRuleListView extends Backbone.View
  template: JST['backbone/templates/account_settings/ticket_validation_rules/attribute_validation_rules_list']
  className: 'validation-rules-list-view'

  events:
    'click .select-all': '_selectAll'
    'click .unselect-all': '_unselectAll'

  initialize: ({type, attributeValidationRulesCollection}) ->
    @type = type
    @attributeValidationRulesCollection = attributeValidationRulesCollection
    @listenTo(@attributeValidationRulesCollection, 'change:presence_validation', @_onAttributesChange)
    @attributeValidationRulesViews = @attributeValidationRulesCollection.models.map((attributeValidationRules) ->
      new AccountSettings.AttributeValidationRulesView({attributeValidationRules: attributeValidationRules})
    )

  render: ->
    @$el.html(@template({
      type: @type
    }))
    @attributeValidationRulesViews.forEach((attributeValidationRulesView) =>
      @$el.find('.validation-rules-list').append(attributeValidationRulesView.render().el)
    )
    @_onAttributesChange()
    @

  _selectAll: ->
    @_toggleCheckedOnAllCheckboxes(true)

  _unselectAll: ->
    @_toggleCheckedOnAllCheckboxes(false)

  _toggleCheckedOnAllCheckboxes: (areChecked) ->
    @attributeValidationRulesViews.forEach(
      (attributeValidationRulesView) -> attributeValidationRulesView.toggleChecked(areChecked)
    )

  _onAttributesChange: ->
    areAllCheckboxSelected = @attributeValidationRulesCollection.models.every(
      (attributeValidationRules) -> attributeValidationRules.get('presence_validation')
    )
    @$('.select-all').toggleClass('d-none', areAllCheckboxSelected)
    @$('.unselect-all').toggleClass('d-none', !areAllCheckboxSelected)

